import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';

export default class ProdutoValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;
        let produto = model;

        if(!produto.idproprodutoerp) {
            refs.codigoInput.focusedOut = true;
            validated = false;
        }

        if (!produto.descricao) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }
        if (produto.marca==null) {
            refs.marcasSelect.focusedOut = true;
            validated = false;
        }
        if (produto.grupoproduto==null) {
            refs.gpSelect.focusedOut = true;
            validated = false;
        }
        if (produto.subgrupoproduto==null) {
            refs.subgrupoInput.focusedOut = true;
            validated = false;
        }
        if (produto.linhaproduto==null) {
            refs.linhaprodutoInput.focusedOut = true;
            validated = false;
        }
        if (produto.codigobarra == ''||produto.codigobarra == null){
            refs.codigoBarraInput.focusedOut = true;
            validated = false;
        }
        if (!validated){
            this.showMessage(new Message('alert', 'msg-campos-obrigatorios', true));
        } 

        return validated;
    }

}